import { useCallback, useEffect, useState } from 'react'
import { getCartTotal, getCart } from '@helpers/cart'
import { getFinancePlans } from '@helpers/finance'
import { get } from 'lodash'

const useLearnMoreModal = () => {
  const highestPriorityFinancePlan = getFinancePlans()?.[0]
  const [showFinanceModal, setShowFinanceModal] = useState(false)
  const modalHtml = get(highestPriorityFinancePlan, 'promoMessage.childMarkdownRemark.html', null)

  const handleClose = () => {
    setShowFinanceModal(false)
  }

  const handleShowModal = () => {
    setShowFinanceModal(true)
  }

  return {
    showModal: showFinanceModal,
    modalHtml,
    handleClose,
    handleShowModal,
  }
}

export default useLearnMoreModal
